import React from "react";
import { corda, hyperledger, ethereum, solidity, polygon } from "../../assets";

import "./skills.css";

const Blockchain = () => {
  return (
    <div className="frontend_section">
      <h1 className="tech__heading">Blockchain</h1>
      <div className="tech__section">
        <div>
          <img src={hyperledger} alt="hyperledger" className="tech__logo" />
          <p>Hyperledger Fabric</p>
        </div>

        <div>
          <img src={corda} alt="corda" className="tech__logo" />
          <p>Corda</p>
        </div>

        <div>
          <img src={ethereum} alt="ethereum" className="tech__logo" />
          <p>Ethereum</p>
        </div>

        {/* <div>
          <img src={hardhat} alt="hardhat" className="tech__logo" />
          <p>Hardhat</p>
        </div>

        <div>
          <img src={ethers} alt="ethers" className="tech__logo" />
          <p>Etherjs</p>
        </div> */}

        <div>
          <img src={polygon} alt="polygon" className="tech__logo" />
          <p>Polygon</p>
        </div>
        <div>
          <img src={solidity} alt="solidity" className="tech__logo" />
          <p>Solidity</p>
        </div>

        {/* <div>
          <img src={openzeppelin} alt="openzeppelin" className="tech__logo" />
          <p>OpenZeppelin</p>
        </div> */}

        {/* <div>
          <img src={chainlink} alt="chainlink" className="tech__logo" />
          <p>Chainlink</p>
        </div> */}

        {/* <div>
          <img src={metamask} alt="metamask" className="tech__logo" />
          <p>Metamask</p>
        </div> */}

        {/* <div>
          <img src={ipfs} alt="ipfs" className="tech__logo" />
          <p>IPFS</p>
        </div> */}
      </div>
    </div>
  );
};

export default Blockchain;
